import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {UtilServiceService} from "src/app/_services/utilService/util-service.service";

@Component({
  selector: 'app-clear-month',
  standalone: false,
  templateUrl: './clear-month.component.html',
  styleUrl: './clear-month.component.scss'
})
export class ClearMonthComponent extends SubscriptionUtil implements OnInit, OnDestroy{
  translate: any;
  dateRangeForm!: FormGroup;
  minDateForEndDate: Date | null = null;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private util: UtilServiceService,
    private modalServc: BsModalService
  ) {
    super();
  }

  ngOnInit(): void {
  this.getLanguageData();
  this.dateRangeForm = new FormGroup({
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl('', Validators.required)
  });

  this.push(
    this.dateRangeForm.get('startDate')!.valueChanges.subscribe((startDate: any) => {
      this.minDateForEndDate = startDate ? new Date(startDate) : null;
      this.dateRangeForm.get('endDate')?.setValue('');
    }),
  );
  }

  // ============================================================
  // Language Translation
  // ============================================================
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }
  push(obs: any) {
    super.push(obs);
  }

  onClearClick(){
    if (this.dateRangeForm.valid) {
      let startDate: any = this.dateRangeForm.get('startDate')?.value;
      let endDate: any = this.dateRangeForm.get('endDate')?.value;
      // Call the service or perform the action to clear the month with the selected date range
      let jsonObj: any = {
        data: {sDate: startDate, eDate: endDate},
        reason: "month_jo_delete",
      };
      this.modalServc.setDismissReason(JSON.stringify(jsonObj));
      this.modalRef.hide();
    } else {
      this.dateRangeForm.markAllAsTouched();
    }
  }
}
